import React from "react";

interface Props {
  value: server.dto.AppointmentType
}

const AppointmentType = (props: Props) => {
  return <div className="inline-flex">
    <div style={{ width: 23 }}>
      <i className={props.value.icon} />
    </div>
    <span className="padding-left-small">{props.value.text}</span>
  </div>
};

export default AppointmentType;